import React, { useState, Fragment, useRef } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import RichTextBoxEditer from "../RichTextBoxEditer";

const RichTextBoxTabPanel = (props: {
  readonly: boolean;
  tabs: any;
  handleTabEditerChange: (val: any, key: any) => void;
}) => {
  const [tabValue, setTabValue] = useState(0);
  const editorRefs = useRef<any[]>([]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    const currentEditor = editorRefs.current[newValue];
    if (currentEditor && currentEditor.joditInstance) {
      currentEditor.joditInstance.focus();
    }
  };

  return (
    <Fragment>
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          "&.MuiTabs-root": {
            backgroundColor: "#F1F5F7",
            minHeight: "34px",
            borderRadius: "8px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          },
          ".MuiTab-root": {
            borderRadius: "6px",
            minHeight: "30px",
            fontSize: "0.875rem",
            "&.Mui-selected": {
              backgroundColor: "#0066FF",
              color: "white",
            },
          },
          ".MuiTabs-indicator": {
            display: "none",
          },
        }}
        TabIndicatorProps={{ sx: { display: "none" } }}
      >
        {props.tabs.map((ele: any) => (
          <Tab key={ele.id} label={ele.label} />
        ))}
      </Tabs>
      {props.tabs.map((ele: any, index: number) => (
        <div
          role="tabpanel"
          hidden={tabValue !== index}
          key={ele.id}
          id={`tabpanel-${index}`}
          aria-labelledby={`tab-${index}`}
        >
          {tabValue === index && (
            <Box sx={{ pt: 3 }}>
              <RichTextBoxEditer
                ref={editorRefs.current[index]}
                readOnly={props.readonly ? true : false}
                editorContent={ele.editerValue}
                onChange={(val) => props.handleTabEditerChange(val, ele.key)}
              />
            </Box>
          )}
        </div>
      ))}
    </Fragment>
  );
};

export default RichTextBoxTabPanel;
